import { createGridExportData } from '@dec/shared';
import { type ColDef } from 'ag-grid-community';
import type Paginated from 'app/core/paginable';
import { buildUrlWithQueryString } from 'app/hooks';
import httpApiApplication from 'app/http/httpApiApplication';
import { t } from 'i18next';
import { ExportExcel } from 'utils/excel';

const CANTIDAD_MAXIMA_A_EXPORTAR = 60000;

type GridRow = Record<string, unknown>;
interface HttpRequester {
  get<T>(path: string): Promise<T>;
}

export const gridExportExcel = async (
  url: string,
  search: Record<string, unknown> | undefined,
  columnDefs: Array<ColDef>,
  requester: HttpRequester = httpApiApplication
) => {
  const newUrl = buildUrlWithQueryString(url, {
    ...search,
    pageSize: CANTIDAD_MAXIMA_A_EXPORTAR,
    page: 1
  });
  const { data: items } = await requester.get<Paginated<GridRow>>(newUrl);

  if (items.length === 0) {
    return;
  }

  const { headers, records } = createGridExportData(columnDefs, items, {
    actionsHeaderLabel: t('common.label.actions')
  });

  await ExportExcel(headers, records, 'data');
};
